export default {
  shared: {
    recentTransactionsTitle: "Movimenti recenti",
    recentTransactionsEmpty: "Nessun movimento ancora",
    recentTransactionsHint: "La tua attività recente apparirà qui",
    loadingData: "Caricamento dati della dashboard...",
    errorLoad: "Errore nel caricamento dei dati della dashboard",
    quickActions: "Azioni rapide",
    title: "Dashboard",
    greetingWithName: "{{greeting}}, {{name}}",
    wallet: "Portafoglio",
  },
  admin: {
    greetingWithName: "{{greeting}}, Staff",
    overviewStats: "Panoramica e statistiche della piattaforma",
    viewSellers: "Visualizza venditori",
    viewSellersDesc: "Gestisci gli account venditori",
    supportTickets: "Ticket di supporto",
    supportTicketsDesc: "Gestisci le richieste di supporto",
    manageActivities: "Attività",
    manageActivitiesDesc: "Rivedi e configura il catalogo",
    manageStructures: "Strutture",
    manageStructuresDesc: "Case, host e chioschi",
    notificationsTitle: "Avvisi operativi",
    notificationsViewAll: "Vedi tutte",
    notificationsLoading: "Caricamento avvisi...",
    notificationsError: "Impossibile caricare gli avvisi",
    notificationsEmpty: "Nessun avviso aperto",
    notificationsMore: "Altri {{count}} — apri la inbox per l'elenco completo",
    statTotalPlatformBalance: "Saldo totale piattaforma",
    statTotalSellers: "Venditori totali",
    statActiveSellers: "{{count}} attivi",
    statTotalActivities: "Attività totali",
    statActiveActivities: "{{count}} attive",
    statActivitiesBreakdown: "{{restaurants}} ristoranti · {{services}} servizi",
    statTotalHouses: "Strutture totali",
    statActiveHouses: "{{count}} attive",
  },
  partner: {
    overview: "Panoramica della tua attività",
    sellerIdMissing: "ID utente venditore non trovato",
    greeting: "Ecco un riepilogo della tua attività",
    myActivities: "Le mie attività",
    myActivitiesDesc: "Gestisci servizi e menu",
    bookings: "Prenotazioni",
    bookingsDesc: "Visualizza le prenotazioni recenti",
    walletDesc: "Controlla i tuoi guadagni",
    statsWalletBalance: "Saldo portafoglio",
    statsAmountOwed: "Importo dovuto",
    statsBookings30d: "Prenotazioni (30 gg)",
    statsRevenue30d: "Ricavi (30 gg)",
    statsTransactions30d: "Transazioni (30 gg)",
    statsTrendVsPrev: "rispetto ai 30 gg precedenti",
  },
  host: {
    myStructures: "Le mie strutture",
    myStructuresDesc: "Gestisci case e dispositivi",
    walletDesc: "Controlla commissioni e pagamenti",
    overview: "Panoramica delle tue strutture",
    hostIdMissing: "ID utente host non trovato",
    greeting: "Ecco un riepilogo delle tue strutture",
  },
  salesAgent: {
    overview: "Panoramica agente di commercio",
    userIdMissing: "ID utente agente di commercio non trovato",
    loading: "Caricamento dashboard...",
    errorLoad: "Errore nel caricamento della dashboard",
    greeting: "Le tue commissioni e le attività/strutture assegnate",
    walletBalance: "Saldo portafoglio",
    amountOwed: "Importo dovuto",
    lifetimeCredits: "Crediti totali (commissioni)",
    assignedScopes: "Ambiti assegnati",
    walletDesc: "Controlla commissioni e pagamenti",
    assignments: "Assegnazioni",
    assignmentsDesc: "Vedi attività e strutture su cui guadagni",
    support: "Supporto",
    supportDesc: "Ottieni aiuto o apri un ticket",
  },
  customer: {
    welcomeTitle: "Bentornato!",
    welcomeDesc:
      "Tieni traccia degli scontrini del ristorante e dei punti fedeltà",
    myBookings: "Le mie prenotazioni",
    myBookingsDesc: "Visualizza e gestisci il caricamento degli scontrini",
    pointsBalance: "Saldo punti",
    pointsCount: "{{count}} punti",
  },
} as const;
